import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";

export const useActivateCustomTheme = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.post(
                `/api/custom_themes/${id}/activate`,
                {},
                {
                    headers: {
                        "Content-Type": "application/ld+json",
                        Accept: "application/ld+json",
                    },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            // Invalidate custom theme cache to refetch the active theme
            queryClient.invalidateQueries(["customTheme"]);
            queryClient.invalidateQueries(["getAllCustomTheme"]);

            // Optional: reload page to ensure theme is fully applied
            // Uncomment if needed for full theme refresh
            // window.location.reload();
        },
    });

    return query;
};
